import { Box } from '@mui/material'
import { Key, useEffect, useMemo, useState } from 'react'
import { Meta, WappInput, WappMode } from '@weblite-wapps/protocol'
import { WapprunnerCreate } from 'weblite-web-wapprunner'
import {
  getStaticPanelByName,
  getStaticPanelByWappId,
  StaticPanelType,
  StaticPanelWappId,
} from '$logic/wapp-panels'

export function StaticWappPanel({
  wappId,
  panelName = undefined,
  input = undefined,
  wapprunnerKey,
  mode,
}: {
  wappId: StaticPanelWappId
  panelName?: StaticPanelType
  input?: WappInput
  wapprunnerKey?: Key
  mode?: WappMode
}) {
  const [wappMeta, setWappMeta] = useState<Meta>()
  const staticPanel = useMemo(
    () =>
      panelName
        ? getStaticPanelByName(panelName)
        : getStaticPanelByWappId(wappId),
    [wappId, panelName],
  )

  useEffect(() => {
    if ('mount' in staticPanel) staticPanel.mount()
    setWappMeta(staticPanel?.getWappMeta())
  }, [staticPanel])

  if (!wappMeta?.wappSessionId) return null
  const { wappSessionId, wisId } = wappMeta

  return (
    <Box sx={{ width: '100%', height: '100%', backgroundColor: 'white' }}>
      <WapprunnerCreate
        key={wapprunnerKey}
        wappSessionId={wappSessionId}
        wappId={wappId}
        wisId={wisId}
        mode={mode ?? WappMode.STATIC}
        input={input}
      />
    </Box>
  )
}
